module.exports = __webpack_public_path__ + "img/icon_lvjing_fugu_hover@2x.7fa9332e.png";